import React from 'react';

export const ApcMark = ({ size = 32, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="APC"
  >
    <rect width="48" height="48" rx="12" fill="#1F6F4A" />
    <path d="M24 10 L34 36 L29.5 36 L27.5 30 L20.5 30 L18.5 36 L14 36 Z M22 25.5 L26 25.5 L24 19.5 Z"
          fill="#FAF9F6" />
    <circle cx="37" cy="12" r="4" fill="#D4A017" />
  </svg>
);

export default ApcMark;
